export var LENDER_PAYMENT_FIELDS = {
  LENDER: 'LENDER',
  APR_MONEYFACTOR: 'APR_MONEYFACTOR',
  RESIDUAL: 'RESIDUAL',
  YEARLY_MILES: 'YEARLY_MILES',
  REBATE: 'REBATE',
  DUEBILLS: 'DUEBILLS',
  FNIMENU: 'FNIMENU',
  DAYS_TO_FIRSTPAYMENT: 'DAYS_TO_FIRSTPAYMENT'
};
export var MORE_FIELDS = {
  FEES: 'FEES',
  TAXES: 'TAXES',
  LOAN_TO_VALUE_RATIO: 'LOAN_TO_VALUE_RATIO',
  SECURITY_DEPOSIT: 'SECURITY_DEPOSIT',
  PAYMENT_FREQUENCY: 'PAYMENT_FREQUENCY',
  FINANCE_ADJUSTED_CAPITAL_COST: 'FINANCE_ADJUSTED_CAPITAL_COST',
  DRIVE_OFF: 'DRIVE_OFF',
  OUT_OF_POCKET_CASH: 'OUT_OF_POCKET_CASH',
  FINANCE_CHARGE: 'FINANCE_CHARGE'
};